import {
  Camera,
  ScanEye,
  Crosshair,
  BellRing,
  Workflow,
  Swords,
  Target,
  Users,
  ArrowDownToLine,
  Cigarette,
  BedDouble,
  Smartphone,
  Shirt,
  ScanFace,
  Cpu,
  Boxes,
  Plug,
  Database,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";

/** Fluxo: Capturar → Interpretar → Identificar → Alertar → Agir */
export interface FlowStep {
  id: string;
  label: string;
  text: string;
  icon: LucideIcon;
}

export const flowSteps: FlowStep[] = [
  {
    id: "capture",
    label: "Capturar",
    text: "Câmeras, botões, catracas e sensores captam o que acontece no ambiente.",
    icon: Camera,
  },
  {
    id: "interpret",
    label: "Interpretar",
    text: "A inteligência artificial analisa a cena em tempo real — vai além da imagem.",
    icon: ScanEye,
  },
  {
    id: "identify",
    label: "Identificar",
    text: "Eventos e comportamentos são reconhecidos automaticamente.",
    icon: Crosshair,
  },
  {
    id: "alert",
    label: "Alertar",
    text: "Alertas personalizados chegam a quem precisa tomar uma decisão.",
    icon: BellRing,
  },
  {
    id: "act",
    label: "Agir",
    text: "O sistema executa a resposta e sincroniza os dados com o ecossistema do cliente.",
    icon: Workflow,
  },
];

/** O que a IA interpreta */
export const detections: { label: string; icon: LucideIcon }[] = [
  { label: "Violência", icon: Swords },
  { label: "Armas", icon: Target },
  { label: "Tumultos", icon: Users },
  { label: "Quedas", icon: ArrowDownToLine },
  { label: "Cigarros", icon: Cigarette },
  { label: "Sono", icon: BedDouble },
  { label: "Uso de celular", icon: Smartphone },
  { label: "Uniformes", icon: Shirt },
  { label: "Reconhecimento facial", icon: ScanFace },
];

/** Tecnologia: seis pilares da plataforma (textos baseados no conteúdo já publicado) */
export const techPillars: {
  title: string;
  text: string;
  icon: LucideIcon;
}[] = [
  {
    title: "Hardware",
    text: "A base física das soluções: equipamentos selecionados para garantir performance e durabilidade.",
    icon: Cpu,
  },
  {
    title: "Inteligência artificial",
    text: "Interpreta cenas e comportamentos em tempo real para gerar alertas.",
    icon: Boxes,
  },
  {
    title: "Software",
    text: "Plataforma integrada ao CRM do cliente, com dados sincronizados automaticamente.",
    icon: Wrench,
  },
  {
    title: "Integrações",
    text: "Versatilidade para se conectar a outras tecnologias e plataformas.",
    icon: Plug,
  },
  {
    title: "Dados",
    text: "Gerenciamento de vídeos e dados com foco em segurança, escalabilidade e velocidade de acesso.",
    icon: Database,
  },
  {
    title: "Automação",
    text: "Automático, inteligente e personalizado: a proteção se adapta a cada ambiente.",
    icon: Zap,
  },
];

/** Narrativa em scroll (01 → 03); 04–08 são contadas pelas seções seguintes. */
export const storyLines: { text: string; highlight?: string }[] = [
  { text: "O mundo está cada vez mais conectado." },
  { text: "Mas apenas capturar imagens não é suficiente." },
  { text: "A Alert AI entende o que está acontecendo.", highlight: "entende" },
];
